import React, { useState, useEffect } from 'react';

const DHBLabel = (props) => {

    // Extract property path name and submitted parameters from component props
    const {dataPath: property, data, schemaOptions: parameters} = props;

    //initializing state for teamLogoUrl
    const [ teamLogoUrl, setTeamLogoUrl ] = useState(null);

    //defining needed constants
    const fieldObject = data[property.replace(/\//g, "")];
    const headerSize = parameters?.labelSize?.value ?? 3;
    const align = parameters?.labelAlign?.value ?? "left";
    const logoPosition = parameters?.logoPosition?.value ?? "left";
    const logoID = fieldObject?.logo;

    //image html code
    const logoHTML = (teamLogoUrl) ? `<img src="${teamLogoUrl}" alt="Club logo" style="max-width: 32px" />` : '';

    // getting media URL and setting state of teamLogoUrl
    useEffect(async () => {
        if(logoID) {
            let baseUrl = location.protocol + '//' + location.host;
            let endPointData = baseUrl + `/admin/api/media/${logoID}?locale=de`;
            try {
                const requestMedia = await fetch(endPointData)
                const returnData = await requestMedia.json();
                setTeamLogoUrl(returnData?.thumbnails['image-150.webp']);
            } catch (e) {
                console.log(e)
            }
        }
    }, [setTeamLogoUrl, logoID, location.protocol, location.host]);

    // Property code for displaying on form
    const componentHtml = `<h${headerSize} style="text-align: ${align}; margin: 0"> ${fieldObject?.name} </h${headerSize}>${logoHTML}`;


    return (
            <div className="dhb-label-default" style={parameters?.twoDots ? {display: 'flex', justifyContent: 'flex-end', alignItems: 'center'} : {display: 'flex'}}>
                <div style={{display: 'flex', alignItems:'center', gap: '20px', height: '45px'}} dangerouslySetInnerHTML={{__html: componentHtml}}/>
                {parameters?.twoDots ? <span style={parameters?.twoDots ? {marginLeft: '20px'} : ''}>:</span> : ''}
            </div>
    );
}

export default DHBLabel;
